<div class="ds-modal__content flag-resolve">
    <dl class="flag-resolve__details">
        <div class="flag-resolve__detail">
            <dt>Category</dt>
            <dd class="flag-resolve__category">
                <svg aria-hidden="true" fill="none" viewBox="0 0 15 15">
                    <path
                        d="M0.0195312 11.8799V0.819336H9.33011L7.34926 3.95738L9.33011 7.08711H1.4487V11.8799H0.0195312Z"
                        [attr.fill]="flag?.categoryColor"
                    />
                </svg>
                {{ flag.category }}
            </dd>
        </div>
        <div class="flag-resolve__detail">
            <dt>Follow up</dt>
            <dd>
                <ng-container *ngIf="flag.followUpTime">
                    {{ flag.followUpTime | date: 'HH:mm' }} {{ flag.timezone }}, {{ flag.followUpTime | date: 'MM/dd/yyyy' }}
                </ng-container>
                <ng-container *ngIf="!flag.followUpTime">No follow up</ng-container>
            </dd>
        </div>
        <div class="flag-resolve__detail">
            <dt>Created</dt>
            <dd>
                <ng-container *ngIf="createdBy">{{ createdBy }}, </ng-container>
                {{ flag.createdOn | date: 'HH:mm' }} {{ flag.timezone }}, {{ flag.createdOn | date: 'MM/dd/yyyy' }}
            </dd>
        </div>
        <div class="flag-resolve__detail flag-resolve__detail--wide">
            <dt>Description</dt>
            <dd class="flag-resolve__long-text">{{ flag.reason }}</dd>
        </div>
    </dl>

    <ds-textarea
        label="Action Taken to Resolve*"
        placeholder="What was the solution?"
        [formControl]="noteControl"
        [maxlength]="1000"
        [minRows]="4"
    >
        <mat-error>Enter a resolution note to continue.</mat-error>
    </ds-textarea>
</div>

<div class="ds-modal__footer">
    <ds-button label="Cancel" theme="secondary-gray" (buttonClick)="cancel.emit()"></ds-button>
    <ds-button label="Resolve Flag" [isLoading]="isSaving" (buttonClick)="resolve.emit()"></ds-button>
</div>
